import { createPromiseAction } from "@adobe/redux-saga-promise";

import { SET_FINANCIAL_PROFILE } from "./types";

export const setFinancialProfile = createPromiseAction(SET_FINANCIAL_PROFILE);
